export default {
  SET_CURRENTCITY(state, payload) {
    state.currentCity = payload;
  },

  SET_CITIES(state, payload) {
    state.cities = payload.cities;
  },

  SET_ABOUT(state, payload) {
    state.pageAbout = payload;
  },

  ADD_DATACITY(state, payload) {
    state.dataPageCities.push({ id: payload.dataCity.id, data: payload.dataCity.doc });
  },

  ADD_BUTTONS(state, payload) {
    state.ctxButtons = payload;
  },

  SET_STATEVIDEO(state, payload) {
    state.videoIsPlaying = payload;
  },

  SET_STATEAUDIO(state, payload) {
    state.userStopAudio = payload;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js